interface Props {
    contentClassName?: string;
    id?: string;
    children?: React.ReactNode;
}

export const ContentWrapper = ({
    children,
    contentClassName,
    id,
}: Props): React.ReactElement<any, any> | null => (
    <div className="content-background" id={id}>
        <div className={`content-width content ${contentClassName ? contentClassName : ''}`}>
            {children}
        </div>
    </div>
);
